/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ converted: NonNullable<unknown>, total: NonNullable<unknown> }} Read_Along_Free_Preview_PagesInputs */

const en_read_along_free_preview_pages = /** @type {(inputs: Read_Along_Free_Preview_PagesInputs) => LocalizedString} */ (i) => {const convertedPlural = registry.plural("en", i?.converted, {});
	if (convertedPlural === "one") return /** @type {LocalizedString} */ (`This free preview reads only the first page of ${i?.total}. Sign up to convert the entire PDF and keep it in your Listening library.`);
	if (convertedPlural === "other") return /** @type {LocalizedString} */ (`This free preview reads the first ${i?.converted} of ${i?.total} pages. Sign up to convert the entire PDF and keep it in your Listening library.`);
	return /** @type {LocalizedString} */ ("read_along_free_preview_pages");
};

const es_read_along_free_preview_pages = /** @type {(inputs: Read_Along_Free_Preview_PagesInputs) => LocalizedString} */ (i) => {const convertedPlural = registry.plural("es", i?.converted, {});
	if (convertedPlural === "one") return /** @type {LocalizedString} */ (`Esta vista previa gratuita lee solo la primera de ${i?.total} páginas. Regístrate para convertir el PDF completo y guardarlo en tu biblioteca de Listening.`);
	if (convertedPlural === "other") return /** @type {LocalizedString} */ (`Esta vista previa gratuita lee las primeras ${i?.converted} de ${i?.total} páginas. Regístrate para convertir el PDF completo y guardarlo en tu biblioteca de Listening.`);
	return /** @type {LocalizedString} */ ("read_along_free_preview_pages");
};

/**
* | convertedPlural | output |
* | --- | --- |
* | "one" | "This free preview reads only the first page of {total}. Sign up to convert the entire PDF and keep it in your Listening library." |
* | "other" | "This free preview reads the first {converted} of {total} pages. Sign up to convert the entire PDF and keep it in your Listening library." |
*
* @param {Read_Along_Free_Preview_PagesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_free_preview_pages = /** @type {((inputs: Read_Along_Free_Preview_PagesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Free_Preview_PagesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_free_preview_pages(inputs)
	return en_read_along_free_preview_pages(inputs)
});